// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductDashboardPricing_container__4BSIs","memberPrompt":"ProductDashboardPricing_memberPrompt__s_6TW"};